import { render, staticRenderFns } from "./PhotoUploadDialog.vue?vue&type=template&id=12a1b89c&"
import script from "./PhotoUploadDialog.vue?vue&type=script&lang=js&"
export * from "./PhotoUploadDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports